import { ref } from "vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { store } from "../store/NyukyoStore";
const log = Log.create("Nyukyo.load");
export const useLoad = () => {
    const loading = ref(false);
    const load = async (nyukyokeiyakuNo) => {
        try {
            loading.value = true;
            await store.load(nyukyokeiyakuNo);
        }
        catch (ex) {
            log.error("load", ex);
            if (ex.status !== 404) {
                MsgBox.error(ex.message);
            }
        }
        finally {
            loading.value = false;
        }
    };
    return {
        loading,
        load
    };
};
